import * as React from "react";
import {FieldProps} from "formik/dist/Field";


const _onChange = (props: any) => (parm1: any,event: any) => {
  const unCheckedNull = props.unCheckedNull ? null : 0
  if (props.setValues) {
    const nextValuesPatch = props.setValues(parm1, event) || {}
    const hasChanges = Object.keys(nextValuesPatch).some(
      key => props.form.values?.[key] !== nextValuesPatch[key],
    )

    if (hasChanges) {
      props.form.setValues({ ...props.form.values, ...nextValuesPatch })
    }
  } else {
    let value
    const {name} = props.field
    // native event
    if (parm1 && parm1.target) {
      const { target } = parm1
      if (target.type === 'checkbox') value = target.checked ? 1 : unCheckedNull
      else value = target ? target.value : null
      // name = target.name;
    } else if (parm1 == null) {
      value = null
    } else {
      value = parm1
    }
    props.form.setFieldValue(name, value)
    if (props.onAfterChange) {
      props.onAfterChange(value)
    }
  }
}

interface FieldPropsProps extends Partial<FieldProps>{
  name? : any,
  value? : any,
  setValues? : any,
  onChange?: any
  /**
   * @deprecated
   */
  onAfterChange? : any
}

const fieldProps = <P extends object>(Component: React.ComponentType<P>) => {
  const FielWithProps: React.ComponentType<P & FieldPropsProps> = (props: P & FieldPropsProps) => {
    // const renderCounter = React.useRef(0)
    // renderCounter.current += 1;
    if((props.field && props.form)){
      const error = props.form.errors?.[props.field.name]
      return (
        <>
          <Component
            name={props.field ? props.field.name : props.name}
            onChange={_onChange(props)}
            value={props.field ? props.field.value : props.value}
            {...props}
          />
          {error && (<div className={"text-danger"}>{error}</div>)}
          {/* renderCounter.current */}
        </>
      )
    }
    return (
      <Component {...props} />
    )
  }
  return FielWithProps
}

export default fieldProps
